<template>
  <div class="map-file">
  <!-- 地图文件管理 -->
  <el-row :gutter="24">
	  
	<el-col :span="6" class="shadow">
	  <!-- 车辆列表部分 -->
	  <div>
		  <!-- 查找参数区 -->
		  <div class="filter-container">
			  <el-input placeholder="请输入机器人ID" v-model="listQueryCar.params.id" style="width: 360px" class="filter-item"></el-input>
			  <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleFilterCar(true)">
				搜索
			  </el-button>
		  </div>
		  <!-- 数据列表区 -->
		  <el-table
			:data="listDataCar"
			v-loading="listLoadingCar"
			border
			highlight-current-row
			style="width: 100%;align: center;">
			<el-table-column prop="index" label="序号" width="60px" align="center">
			</el-table-column>
			<el-table-column prop="name" label="机器人名称" align="center">
			</el-table-column>
			<el-table-column prop="operator" label="操作" align="center">
			  <template v-slot:="{row,$index}">
				<el-button type="primary" size="mini" @click="handleShowMapPackList(row)">
				  查看地图包
				</el-button>
			  </template>
			</el-table-column>
		  </el-table>
      
		  <!-- 分页栏 -->
		  <pagination :total="totalCountsCar" :page="listQueryCar.pageIndex" layout='sizes,prev, pager, next'
			@pagination="handlePageChangeCar" small :pager-count="5" >
		  </pagination>
		</div>
	</el-col>
	
	<!-- 文件列表部分 -->
    <el-col :span="18" class="shadow">
      <div style="100%">
		  
        <!-- 展示车辆ID -->
        <div class="car-id">
            地图文件所属机器人ID:
            <el-input
              style="width: 310px"
              placeholder=""
              v-model="curCarId"
              :disabled="true">
            </el-input>
			<el-input style="display: none;"  v-model="curCarName"> </el-input>
        </div>
		
		<el-col :span="14" >
				<!-- 数据列表区 -->
				<el-table
				  :data="listDataMapPack.slice((currentMapPackPage - 1) * mapPackPageSize,currentMapPackPage * mapPackPageSize)"
				  v-loading="listLoadingMapPack"
				  border
				  highlight-current-row
				  style="width: 100%;align: center;">
				  <el-table-column prop="index" label="序号" width="60px" align="center">
				  </el-table-column>
				  <el-table-column prop="mapPackName" label="地图包名称" width="150px" align="center">
				  </el-table-column>
				  <!-- <el-table-column prop="mapPackNum" label="地图包编号" width="180px" align="center">
				  </el-table-column> -->
				  <el-table-column prop="mapPackStatusStr" label="地图包状态" width="150px" align="center">
				  </el-table-column>
				  <el-table-column prop="operator" label="操作" align="center">
				    <template v-slot:="{row,$index}">
				      <el-button-group>
				        <el-button type="primary" size="mini" @click="handleFilterMapFile(row.mapPackName,row.mapPackNum)">
				          查看地图
				        </el-button>
				        <el-button type="primary" size="mini" style="margin-left:10px" @click="handleFilterTrajFile(row.mapPackName,row.mapPackNum)">
				          查看轨迹
				        </el-button>
				        <el-button type="primary" size="mini" style="margin-left:10px" @click="handleFilterTaskFile(row)">
				          查看任务
				        </el-button>
						<el-button v-if="loginuser == 'admin'" type="primary" size="mini" style="margin-left:10px" @click="handleAddTrajFile(row)">
						 添加轨迹
						</el-button>
				      </el-button-group>
				    </template>
				  </el-table-column>
				</el-table>
				
				<!-- 分页栏 -->
				<pagination :total="mapPackTotal" layout='sizes,prev, pager, next' v-if="mapPackTotal!=0"
				  @pagination="handlePageChangeMapPack">
				</pagination>
			</el-col>
			
			<el-col :span="10" >
				<!-- 数据列表区 -->
				<el-table
				  :data="listDataTrack.slice((currentTrackPage - 1) * trackPageSize,currentTrackPage * trackPageSize)"
				  v-loading="listLoadingTrack"
				  border
				  highlight-current-row
				  style="width: 100%;align: center;">
				  <el-table-column prop="index" label="序号" width="60px" align="center">
				  </el-table-column>
				  <el-table-column prop="mapPackName" label="差分轨迹名称" width="160px" align="center">
				  </el-table-column>
				 <!-- <el-table-column prop="mapPackNum" label="差分轨迹编号" width="180px" align="center">
				  </el-table-column> -->
				  <el-table-column prop="mapPackStatusStr" label="差分轨迹状态" width="180px" align="center">
				  </el-table-column>
				  <el-table-column prop="operator" label="操作" align="center">
				    <template v-slot:="{row,$index}">
				      <el-button type="primary" size="mini"  @click="handleFilterTrajFile(row.mapPackName,row.mapPackNum)">
				        查看
				      </el-button>
				    </template>
				  </el-table-column>
				</el-table>
				
				<!-- 分页栏 -->
				<pagination :total="trackTotal" layout='sizes,prev, pager, next' v-if="trackTotal!=0"
				  @pagination="handlePageChangeTrack">
				</pagination>
			</el-col>
      </div>
    </el-col>
  </el-row>

  <!-- 查看地图模态框：弹出框展示地图或路径文件与相关操作 -->
  <el-dialog :title="fileDialogTitle" :visible.sync="mapOrTrajFileDialogVisable" top="8vh" width="50%" :before-close="closeFileDialog">
    <div>
      <!-- 文件上传区 -->
      <el-upload
        v-if="showFileUpload"
        :multiple="false"
        class="upload-demo"
        ref="upload"
        name="mfile"
        action="/api/file/localUpload"
        :headers="uploadHeaders"
        :data="uploadData"
        :before-upload="beforeUpload"
        :on-success="successUpload"
        :on-error="errorUpload"
        accept=".jpg,.png,.pgm,.pcd,.traj,.PGM,.PCD,.JPG,.PNG,.json"
        :file-list="file_list"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary" icon="el-icon-paperclip">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传<i class="el-icon-upload el-icon--right"></i></el-button>
        <div slot="tip" class="el-upload__tip">上传地图文件</div>
      </el-upload>
      <!-- 数据列表区 -->
      <el-table
        :data="listDataFile.slice((currentFilePage - 1) * filePageSize,currentFilePage * filePageSize)"
        v-loading="listLoadingFile"
        border
        highlight-current-row
        style="width: 100%;align: center;">
        <el-table-column prop="index" label="序号" width="60px" align="center">
        </el-table-column>
        <el-table-column prop="fileName" label="文件名" align="center">
        </el-table-column>
        <el-table-column prop="operator" label="操作" align="center">
          <template v-slot:="{row,$index}">
         <!-- <div v-if="row.fileName.split('.').pop().toLowerCase()=='pgm'"> -->
         <!-- <el-popover
          v-if="row.fileName.split('.').pop().toLowerCase()=='pgm'"
          placement="top"
          width="250"
          trigger="hover"
          >
          <p>请选择修图方式？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="success" @click="handlePSOnline(row)">在线修图</el-button>
            <el-button type="primary" size="mini" @click="handlePS(row)">Photoshop</el-button>
            <el-button type="danger" size="mini" @click="handlePGMPreview(row)">预览</el-button>
          </div>
          <el-button slot="reference" type="info" size="mini" @click="popoverVisible=true">修图</el-button>
			   </el-popover> -->
         <!-- </div> -->
			  <el-button-group>
				<el-button type="primary" size="mini" @click="handleFilePreview(row)" :disabled="row.fileName.split('.').pop().toLowerCase()!='png'">
					预览
				</el-button>
				<el-button type="success" size="mini" @click="handleFileDownload(row)">
					下载
				</el-button>
				<el-button type="danger" size="mini" @click="handleFileDelete(row)">
					删除
				</el-button>
			  </el-button-group>
           
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页栏 -->
      <pagination :total="fileTotal"
        @pagination="handlePageChangeFile">
      </pagination>
    </div>

    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="closeFileDialog">取 消</el-button>
      <el-button type="primary" @click="closeFileDialog">确 定</el-button>
    </span> -->
	
  </el-dialog>

 <!-- 地图或路径弹出页（fileDialogTitle）的操作弹出框：png/jpg图片预览 -->
  <el-dialog title="预览图片" :visible.sync="priviewImageVisable" width="30%">
    <div>
      <el-image
      style=""
      :src="url"
      fit="contain"></el-image>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="priviewImageVisable = false">取 消</el-button>
      <el-button type="primary" @click="priviewImageVisable = false">确 定</el-button>
    </span>
  </el-dialog>
  
  <!-- 查看任务弹出框 -->
  <el-dialog :title="taskDialogTitle" :visible.sync="taskDialogVisible" top="8vh" width="60%"> 
    <div>
      <!-- 数据列表区 -->
      <el-table
        :data="listTaskFile.slice((currentTaskPage - 1) * taskPageSize,currentTaskPage * taskPageSize)"
        v-loading="listLoadingTask"
        border
        highlight-current-row
        style="width: 100%;align: center;">
        <el-table-column prop="index" label="序号" width="60px" align="center"> </el-table-column>
        <el-table-column prop="missionName" label="任务名称" align="center"></el-table-column>
		<el-table-column prop="missionMap" label="地图名称" align="center"></el-table-column>
		<el-table-column prop="missionFunc" label="执行操作" align="center"></el-table-column>
		<el-table-column prop="userName" label="创建人" align="center"></el-table-column>
       <!-- <el-table-column prop="missionItem" label="操作" align="center">			
          <template v-slot:="{row,$index}">
			  <el-button-group>				
				<el-button type="success" size="mini" @click="handleTaskSend(row)">
					下发
				</el-button>
			  </el-button-group>          
          </template>
        </el-table-column> -->
      </el-table>
      
      <!-- 分页栏 -->
      <pagination :total="taskTotalNum"
        @pagination="handleTaskChangeFile">
      </pagination>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="taskDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="taskDialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>

	<!--轨迹记录添加 用于 高精地图画轨 -->
   <el-dialog :title="hdmapDialogTitle" :visible.sync="hdmapDialogVisible" top="8vh" width="60%"> 	
	  <el-form :model="editHdmapTraj" ref="editHdmapTraj" label-position="right" label-width="80px">
<!-- 		<el-form-item label="配置用户" prop="trajuser">
		  <el-input v-model="editHdmapTraj.trajuser" :disabled="true"></el-input>
		</el-form-item> 
	  	<el-form-item label="添加用户">
	  		<el-select v-model="editHdmapTraj.trajuser" style="width:100%">
	  			<el-option v-for="item in usersOptions" :key="item.value" :label="item.label" :value="item.value">
	  			</el-option>
	  		</el-select>
	  	</el-form-item> -->	
		<el-form-item label="轨迹ID" prop="trajid">
			<el-col :span="6">
				<el-input v-model="editHdmapTraj.trajid" :readonly="true"></el-input>
			</el-col>
		  <p style="color: darkorange;padding-left: 10px;">-traj.png</p>
		</el-form-item>
		<el-form-item label="轨迹名称" prop="trajname">
		  <el-input v-model="editHdmapTraj.trajname"  placeholder="限6位汉字/字母/数字"
		   @input="val => editHdmapTraj.trajname = val.replace(/[^a-zA-Z0-9\u4E00-\u9FA5]/g, '')"  maxlength="6">
		   </el-input>
		</el-form-item>
	  </el-form>
	  <div slot="footer" class="dialog-footer">
	  	<el-button @click="hdmapDialogVisible = false">取 消</el-button>
	  	<el-button type="primary" @click="handleInsertHdMapTrajForm()">确 定</el-button>
	  </div>
   </el-dialog>
	

  <el-dialog
    title="修图"
    :visible.sync="psDialogVisible"
    width="30%"
    :fullscreen="true"
    :before-close="handlePSClose">
    <div class="ps">
    <tui-image-editor ref="ps"
                      :include-ui="useDefaultUI"
                      :options="options"
                      v-if="psDialogVisible"
                      >
    </tui-image-editor>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="psDialogVisible = false">取 消</el-button> -->
      <!-- <el-button @click="cancleBrush">擦除</el-button>
      <el-button @click="addBrush">添加</el-button> -->
      <el-button @click="setBrush" type="success">实线</el-button>
      <el-divider direction="vertical"></el-divider>
      <el-popconfirm
        title="确定保存？该操作不可撤销"
        @onConfirm="handlePSConfirm" >
        <el-button slot="reference" type="primary" >保 存</el-button>
      </el-popconfirm>
    </span>
  </el-dialog>


  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import {carList} from '@/api/car'
import {fileList,filePreview,localDown,localDelete,listMapPack,addTraj} from '@/api/file'
import {taskList,execTask} from '@/api/task'
// import {listCarUserByEntity} from '@/api/user.js'

// To use the basic UI, the svg files for the icons is required.
import 'tui-image-editor/dist/svg/icon-a.svg';
import 'tui-image-editor/dist/svg/icon-b.svg';
import 'tui-image-editor/dist/svg/icon-c.svg';
import 'tui-image-editor/dist/svg/icon-d.svg';
// Load Style Code
import 'tui-image-editor/dist/tui-image-editor.css';
import "tui-color-picker/dist/tui-color-picker.css";
import {ImageEditor} from '@toast-ui/vue-image-editor';

const locale_zh = {
  // override default English locale to your custom
  Crop: "裁剪",
  DeleteAll: "全部删除",
  Delete: "删除",
  Undo: "撤销",
  Redo: "反撤销",
  Reset: "重置",
  Flip: "镜像",
  Rotate: "旋转",
  Draw: "画",
  Shape: "形状标注",
  Icon: "图标标注",
  Text: "文字标注",
  Mask: "遮罩",
  Filter: "滤镜",
  Bold: "加粗",
  Italic: "斜体",
  Underline: "下划线",
  Left: "左对齐",
  Center: "居中",
  Right: "右对齐",
  Color: "颜色",
  "Text size": "字体大小",
  Custom: "自定义",
  Square: "正方形",
  Apply: "应用",
  Cancel: "取消",
  "Flip X": "X 轴",
  "Flip Y": "Y 轴",
  Range: "粗细",
  Stroke: "描边",
  Fill: "填充",
  Circle: "圆",
  Triangle: "三角",
  Rectangle: "矩形",
  Free: "曲线",
  Straight: "直线",
  Arrow: "箭头",
  "Arrow-2": "箭头2",
  "Arrow-3": "箭头3",
  "Star-1": "星星1",
  "Star-2": "星星2",
  Polygon: "多边形",
  Location: "定位",
  Heart: "心形",
  Bubble: "气泡",
  "Custom icon": "自定义图标",
  "Load Mask Image": "加载蒙层图片",
  Grayscale: "灰度",
  Blur: "模糊",
  Sharpen: "锐化",
  Emboss: "浮雕",
  "Remove White": "除去白色",
  Distance: "距离",
  Brightness: "亮度",
  Noise: "噪音",
  "Color Filter": "彩色滤镜",
  Sepia: "棕色",
  Sepia2: "棕色2",
  Invert: "负片",
  Pixelate: "像素化",
  Threshold: "阈值",
  Tint: "色调",
  Multiply: "正片叠底",
  Blend: "混合色"
  // etc...
};

const customTheme = {
  // image 坐上角度图片
  "common.bi.image": "", // 在这里换上你喜欢的logo图片
  "common.bisize.width": "0px",
  "common.bisize.height": "0px",
  "common.backgroundImage": "none",
  "common.backgroundColor": "#f3f4f6",
  "common.border": "1px solid #444",

  // header
  "header.backgroundImage": "none",
  "header.backgroundColor": "#f3f4f6",
  "header.border": "0px",

  // load button
  "loadButton.backgroundColor": "#fff",
  "loadButton.border": "1px solid #ddd",
  "loadButton.color": "#222",
  "loadButton.fontFamily": "NotoSans, sans-serif",
  "loadButton.fontSize": "12px",
  "loadButton.display": "none", // 可以直接隐藏掉

  // download button
  "downloadButton.backgroundColor": "#fdba3b",
  "downloadButton.border": "1px solid #fdba3b",
  "downloadButton.color": "#fff",
  "downloadButton.fontFamily": "NotoSans, sans-serif",
  "downloadButton.fontSize": "12px",
  "downloadButton.display": "none", // 可以直接隐藏掉

  // icons default
  "menu.normalIcon.color": "#8a8a8a",
  "menu.activeIcon.color": "#555555",
  "menu.disabledIcon.color": "#434343",
  "menu.hoverIcon.color": "#e9e9e9",
  "submenu.normalIcon.color": "#8a8a8a",
  "submenu.activeIcon.color": "#e9e9e9",

  "menu.iconSize.width": "24px",
  "menu.iconSize.height": "24px",
  "submenu.iconSize.width": "32px",
  "submenu.iconSize.height": "32px",

  // submenu primary color
  "submenu.backgroundColor": "#1e1e1e",
  "submenu.partition.color": "#858585",

  // submenu labels
  "submenu.normalLabel.color": "#858585",
  "submenu.normalLabel.fontWeight": "lighter",
  "submenu.activeLabel.color": "#fff",
  "submenu.activeLabel.fontWeight": "lighter",

  // checkbox style
  "checkbox.border": "1px solid #ccc",
  "checkbox.backgroundColor": "#fff",

  // rango style
  "range.pointer.color": "#fff",
  "range.bar.color": "#666",
  "range.subbar.color": "#d1d1d1",

  "range.disabledPointer.color": "#414141",
  "range.disabledBar.color": "#282828",
  "range.disabledSubbar.color": "#414141",

  "range.value.color": "#fff",
  "range.value.fontWeight": "lighter",
  "range.value.fontSize": "11px",
  "range.value.border": "1px solid #353535",
  "range.value.backgroundColor": "#151515",
  "range.title.color": "#fff",
  "range.title.fontWeight": "lighter",

  // colorpicker style
  "colorpicker.button.border": "1px solid #1e1e1e",
  "colorpicker.title.color": "#fff"
};

String.prototype.colorHex = function(){
    var that = this;
    //十六进制颜色值的正则表达式
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    // 如果是rgb颜色表示
    if (/^(rgb|RGB)/.test(that)) {
        var aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
        var strHex = "#";
        for (var i=0; i<aColor.length; i++) {
            var hex = Number(aColor[i]).toString(16);
            if (hex.length < 2) {
                hex = '0' + hex;    
            }
            strHex += hex;
        }
        if (strHex.length !== 7) {
            strHex = that;    
        }
        return strHex;
    } else if (reg.test(that)) {
        var aNum = that.replace(/#/,"").split("");
        if (aNum.length === 6) {
            return that;    
        } else if(aNum.length === 3) {
            var numHex = "#";
            for (var i=0; i<aNum.length; i+=1) {
                numHex += (aNum[i] + aNum[i]);
            }
            return numHex;
        }
    }
    return that;
};

export default {
  name: 'MapFile',
  components: {
    Pagination,'tui-image-editor': ImageEditor
  },
  data(){
      return{
		loginuser:this.$store.getters['user/userName'],
        // 车辆列表部分
        listLoadingCar: true,
        listDataCar: [],
        totalCountsCar: 0,
        listQueryCar: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          params: {
            id: undefined
          },
          fuzzySearch: true
        },
        //文件上传
        file_list:[],
        uploadHeaders:{authorization:this.$store.state.user.authorization},
        uploadData:{
            command_id:32,
            flag:"1",
            carId:this.curCarId,
            mapPackNum:this.curMapPackNum
            
        },
        //地图包列表部分
        curCarId:undefined,
		curCarName:'',
        listLoadingMapPack: false,
        listDataMapPack: [],
        currentMapPackPage: 1,//当前地图包列表页码
        mapPackPageSize: 10,//每页展示地图包数据条数
        mapPackTotal: 0,//地图包列表数据总条数


        //文件列表部分
        curMapPackName:undefined,//地图包名称-显示使用
        curMapPackNum:undefined,//地图包编号-显示以及查询文件使用
        listLoadingFile: false,
        listDataFile:[],
        fileDialogTitle:"",
        mapOrTrajFileDialogVisable:false,
        currentFilePage: 1,
        filePageSize: 10,
        fileTotal: 0,
        fileDialogFlag: 1,//文件列表弹出框标记 1、查看地图 2、查看轨迹


        // totalCountsFile:0,
        // listQueryFile:{
          // pageIndex: 1,
          // pageSize: 10,
          // params: {
          //   id: undefined
          // },
          // fuzzySearch: true
        // },
        showFileUpload:false,
        //图片预览部分
        curFileName:undefined,
        priviewImageVisable:false,
        curRow:undefined,
        url:"",
        psDialogVisible:false,
        useDefaultUI: true,
        options: {},
			
		 //任务列表弹出框相关
		curMapPackName:undefined,
		listLoadingTask: false,
		listTaskFile:[],
		taskDialogTitle:"",
	    taskDialogVisible:false,
	    currentTaskPage: 1,
		taskPageSize: 10,
		taskTotalNum: 0,
			
		//添加轨迹记录用于高精地图绘制轨迹
		hdmapDialogVisible:false,
		hdmapDialogTitle:'',
		usersOptions:[],
		editHdmapTraj:{
			mapid:'',
			trajuser:'',
			trajname:'',
			trajid:'',
			carid:''
		},
		
		//差分轨迹
		listLoadingTrack:false,
		listDataTrack:[],
		currentTrackPage:1,
		trackPageSize:10,
		trackTotal:0

      }
  },
  methods: {
    /**
     * handleFilterCar 用于请求车辆数据
     */
    handleFilterCar(isNewSearch = false) {
      //如果是“新搜索”（即非翻页，而是点击搜索按钮进行搜索）
      if(isNewSearch) {
        //页数修改1
        this.listQueryCar.pageIndex = 1;
        //清空地图包列表
        this.clearMapPackList();
      }

      this.listLoadingCar = true
      carList(this.listQueryCar, null).then(res => {
        let data = res.pageData
        this.totalCountsCar = data.totalCounts
		if(data.datas!=null && data.datas.length > 0){
			// 对后端数据进行解析
			this.listDataCar = data.datas.map((item,index) => {
			  return {
			    index: index+1,
			    id: item.id,
			    name: item.name
			  }
			})
		}
        this.listLoadingCar = false
      })
    },
    /**
     * 处理小车列表翻页
     * 
     */
    handlePageChangeCar(data) {
      this.listQueryCar.pageIndex = data.page
      this.listQueryCar.pageSize = data.limit
      this.handleFilterCar()
    },

	/**
	 * 
	 * 展示当前车辆下地图文件
	 */
    handleShowMapPackList(row) {
      this.listLoadingMapPack = true
	  this.listLoadingTrack = true
      this.curCarId=row.id
	  this.curCarName = row.name
      this.url = "";
	  this.listDataMapPack = []
	  this.listDataTrack = []
	  
      listMapPack(row.id).then(res => {
        if(res.result === "1") {
            let data = res.data;
			if(data!=null && data.length > 0){
				//由于后端是直接从FTP中获取文件夹列表，所以此处需要进行前端分页操作
				data.forEach((item,index) =>{
					var flag = item.flag
					var bean = {
						index: index+1,
						mapPackName: item.mapPackName,
						mapPackNum: item.mapPackNum,
						mapPackId:item.mapPackId,
						mapPackStatusStr:item.mapPackStatus == 1 ? '已删' :'正常',
						users:item.users
					}
					if(flag == 2){
						this.listDataTrack.push(bean)
					}else{
						this.listDataMapPack.push(bean)
					}
				})
				// this.listDataMapPack = data.map((item,index) => {
				//   return {
				//     index: index+1,
				//     mapPackName: item.mapPackName,
				//     mapPackNum: item.mapPackNum,
				// 	mapPackId:item.mapPackId,
				// 	mapPackStatusStr:item.mapPackStatus == 1 ? '已删' :'正常',
				// 	users:item.users
				//   }
				// })
			}
        } else {
          this.$message.error(res.message);
        }
        this.mapPackTotal = this.listDataMapPack.length;
        this.listLoadingMapPack = false;
		
		this.trackTotal = this.listDataTrack.length
		this.listLoadingTrack = false;
      })
    },
    clearMapPackList() {
      this.curCarId = undefined;
      this.curCarName = "";
      this.url = "";
      this.listDataMapPack = [];
      this.mapPackTotal = this.listDataMapPack.length;
    },

    /**
     * 处理地图列表翻页
     * 
     */
    handlePageChangeMapPack(data) {
      this.currentMapPackPage = data.page;
      this.mapPackPageSize = data.limit;
    },
	
	/**
	 *  处理差分轨迹列表翻页
	 */
	handlePageChangeTrack(data){
		this.currentTrackPage = data.page;
		this.trackPageSize = data.limit;
	},

    /**
     * 选择一辆小车展示文件列表
     *
     */
    handleShowFileList(row){
        this.handleFilterFile()
    },

	/**
	 *
	 * 显示当前车辆下地图文件
	 */
    handleFilterMapFile(mapPackName,mapPackNum) {
      //当前操作为查看地图，在此模态框的操作均为地图操作
      this.fileDialogFlag = 1;

	  this.listDataFile = [];	
      this.curMapPackName = mapPackName;
      this.curMapPackNum = mapPackNum;
      this.url="";
      this.showFileUpload=true;
      this.fileDialogTitle = "地图包[" + this.curMapPackName + "]地图文件";

      this.mapOrTrajFileDialogVisable = true;
      this.listLoadingFile = true
      fileList(this.fileDialogFlag,this.curCarId,this.curMapPackNum).then(res => {
        if(res.result==="1"){
          let data = res.fileLists
          // this.totalCountsFile = data.totalCounts
		  if(data != null && data.length > 0){
			  // 对后端数据进行解析
			  this.listDataFile = data.map((item,index) => {
			    return {
			      index: index+1,
			      fileName: item,
			    }
			  })
		  }
        }else{
            this.$message.error(res.message)
        }
        this.fileTotal = this.listDataFile.length;
        this.listLoadingFile = false
      })
    },
	
	/**
	 * 
	 * 显示当前地图下路径文件
	 */
    handleFilterTrajFile(mapPackName,mapPackNum) {

      //当前操作为查看轨迹，在此模态框的操作均为轨迹操作
      this.fileDialogFlag = 2;

	  this.listDataFile = [];
      this.curMapPackName = mapPackName;
      this.curMapPackNum = mapPackNum;
      this.url=""
      this.showFileUpload=true,
      this.fileDialogTitle = "地图包[" + this.curMapPackName + "]轨迹文件";
      this.mapOrTrajFileDialogVisable = true;
      this.listLoadingFile = true
      fileList(this.fileDialogFlag,this.curCarId,this.curMapPackNum).then(res => {
        if(res.result==="1"){
          let data = res.fileLists
          // this.totalCountsFile = data.totalCounts
		   if(data != null && data.length > 0){
			   // 对后端数据进行解析
			   this.listDataFile = data.map((item,index) => {
			     return {
			       index: index+1,
			       fileName: item,
			     }
			   })
		   }
        }else{
            this.$message.error(res.message)
        }
        this.fileTotal = this.listDataFile.length;
        this.listLoadingFile = false
      })
    },
    closeFileDialog() {
      this.curMapPackName = undefined;
      this.curMapPackNum = undefined;
      this.$refs.upload.clearFiles();
	  this.listDataFile = [];
      this.mapOrTrajFileDialogVisable = false;
    },
	/**
	 * @param {Object} data
	 * 处理翻页
	 */
    handlePageChangeFile(data) {
      this.currentFilePage = data.page;
      this.filePageSize = data.limit;
    },
	
	/**
	 * 查看当前车辆下任务列表
	 */
	handleFilterTaskFile(rowdata){
		this.listTaskFile = [];
		this.taskDialogVisible = true
		this.mapOrTrajFileDialogVisable = false
		this.psDialogVisible = false
		this.taskDialogTitle = "当前机器人："+ this.curCarName + "; 当前地图："+rowdata.mapPackName+"["+ rowdata.mapPackNum+"]" ; 
		this.listLoadingTask = true
		taskList(rowdata.mapPackNum).then(res => {
		  if(res.result==="1"){
		    let data = res.data
			if(data != null && data.length > 0){
				 // 对后端数据进行解析
				 this.listTaskFile = data.map((item,index) => {
				   return {
				     index: index+1,
				     missionName:item.missionName,
				 	userName:item.userid,
				 	missionMap:item.missionMap,
				 	missionFunc:item.missionFunc,
				 	missionItem:item,
				   }
				 })
			}
		  }else{
		      this.$message.error(res.message)
		  }
		  this.taskTotalNum = this.listTaskFile.length;
		  this.listLoadingTask = false
		})
		
	},
	/**
	 * 
	 * 任务下发
	 */
	handleTaskSend(data){
		console.log("开始执行:\n", data)
		var mission = data.missionItem
		var carId = this.curCarId
		execTask(carId,mission).then(res => {
		  if (res.result != "200") {
		    this.$message.error(res.message)
		    return
		  } else {
		    this.$message.success(res.message)
		    this.taskDialogVisible = false
		  }
		})
	},
	/**
	 * 
	 * 处理任务列表翻页
	 */
	handleTaskChangeFile(data){
		this.currentTaskPage = data.page;
		this.taskPageSize = data.limit;
	},
	
	/**
	 * @param {Object} row
	 * 添加轨迹记录
	 * 用于高精地图绘制轨迹
	 */
	handleAddTrajFile(row){
		this.hdmapDialogTitle = "当前机器人："+ this.curCarName +";当前地图：" + row.mapPackName ;
		this.editHdmapTraj.carid = this.curCarId
		this.editHdmapTraj.mapid = row.mapPackNum
		this.editHdmapTraj.trajuser = row.users
		this.editHdmapTraj.trajid = new Date().getTime()
		this.hdmapDialogVisible = true	
	},
	/**
	 * 录入轨迹信息
	 * 轨迹用户关联信息
	 */
	handleInsertHdMapTrajForm(){
		if(this.editHdmapTraj.trajuser == ''){
		  this.$alert('用户选择不能为空')
		  return
		}else if(this.editHdmapTraj.trajname == ''){
			this.$alert('轨迹名称不能为空')
			return
		}else{
		  addTraj(this.editHdmapTraj).then(res => {
		  	if (res.result == '200') {
		  		this.$alert('添加成功！');
		  		this.hdmapDialogVisible = false;
		  	} else {
		  		this.$alert(res.message);
				this.hdmapDialogVisible = true	
		  	}
		  })
		}
	},

	
    /**
     * 提交上传文件
     */
    submitUpload(){
        this.uploadData.carId=this.curCarId
        this.uploadData.mapPackNum=this.curMapPackNum
        this.$refs.upload.submit();
    },
    /**
     * 上传前检查文件
     * @param {Object} file
     */
    beforeUpload(file){
        if(!/\.(jpg|png|pgm|pcd|traj|PGM|PCD|JPG|PNG|json|JSON)$/.test(file.name)){
            this.$message({
              type: 'info',
              message: '图片类型必须是.jpg,png,pgm,pcd,traj中的一种!'
            });
            return false
        }
		let reg = /[\u4e00-\u9fa5]/g;
		if(file.name.indexOf(" ")!=-1 || reg.test(file.name)){
			this.$message({
			  type: 'info',
			  message: '文件名不能包含中文和空格！'
			});
			return false
		}
		if(file.size==0){
			this.$message({
			  type: 'info',
			  message: '文件大小为0KB，请重新选择文件！'
			});
			return false
		}
        return true
    },
    /**
     * 上传成功
     * @param {Object} res
     * @param {Object} file
     * @param {Object} fileList
     */
    successUpload(res, file, fileList){
        if(res.result==="0"){
            //显示上传成功信息
            this.$message({
                message: res.message,
                type: 'success'
            })
            //清空上传文件列表
            this.$refs.upload.clearFiles();
            //上传成功刷新数据
            if(this.fileDialogFlag == 1) {
              this.handleFilterMapFile(this.curMapPackName,this.curMapPackNum)
            } else {
              this.handleFilterTrajFile(this.curMapPackName,this.curMapPackNum)
            }

        }else{
            this.$message.error(res.message)
        }
    },
    /**
     * 上传发生错误
     * @param {Object} err
     * @param {Object} file
     * @param {Object} fileList
     */
    errorUpload(err, file, fileList){
        this.$message.error(err)
    },
    /**
     * 处理预览
     * @param {Object} row
     */
    handleFilePreview(row){
        // this.url='/api/file/filePreview?flag=1&carId='+this.curCarId+"&fileName="+row.fileName
        // filePreview
        localDown("1",this.curCarId,this.curMapPackNum,row.fileName).then(res=>{
            this.url=window.URL.createObjectURL(new Blob([res]))
            this.priviewImageVisable = true;
        })
    },
    handlePGMPreview(row){
      this.url=''
      this.url='https://pgm.techinao.com/get/'+this.curCarId+'/'+row.fileName
    },
    /**
     * 处理文件下载
     * @param {Object} row
     */
    handleFileDownload(row){
        localDown("1",this.curCarId,this.curMapPackNum,row.fileName)
        .then(res=>{
            this.download(res,row.fileName)
        })
    },
    // 下载文件
    download (data,fileName) {
        if (!data) {
            return
        }
        let url = window.URL.createObjectURL(new Blob([data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)

        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
    },
    //删除文件
    handleFileDelete(row){
        if(this.listDataFile.length<=1){
            this.$message({
              type: 'info',
              message: '删除失败，必须保留一个文件!'
            });
        }else{
			this.$confirm('确定要删除吗？', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'	
			}).then(() => {
				localDelete("1",this.curCarId,this.curMapPackNum,row.fileName).then(res=>{
				    if(res.result==="0"){
				       this.$message({
				          message: res.message,
				          type: 'success'
				      })
              //成功刷新数据
              if(this.fileDialogFlag == 1) {
                this.handleFilterMapFile(this.curMapPackName,this.curMapPackNum)
              } else {
                this.handleFilterTrajFile(this.curMapPackName,this.curMapPackNum)
              }
				    }else{
				        this.$message.error(res.message)
				    }
				})
        // localDown("1",this.curCarId,'').then(res=>{
        //     console.log(res)
        //     this.url=window.URL.createObjectURL(new Blob([res]))
        // })
			} ).catch(e=>e)
        }
    },
    handlePS(row){
      this.handleFileDownload(row)
      this.$alert('使用Photoshop打开下载的图片修完图后导出pgm重新上传即可', '提示', {
        confirmButtonText: '确定',
      });
      window.location.href="adbps://"
    },
    handlePSOnline(row){
      this.curRow=row
      this.options={
          includeUI: {
              loadImage: {
                  path: 'https://pgm.techinao.com/get/'+this.curCarId+'/'+row.fileName,
                  name: row.fileName
              },
              initMenu: 'draw',
              locale:locale_zh,
              // theme:customTheme,
          },
          cssMaxWidth: 1000,
          cssMaxHeight: 1000,
          // selectionStyle:{
          //   transparentCorners:false
          // }
          usageStatistics:false,
      },
      this.psDialogVisible=true
      setTimeout(()=>{
        this.$message.info('需要绘制实线时，请点击实线')
      },100)
    },
    handlePSClose(done) {
      this.$confirm('确认关闭？所有修改将会丢失')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handlePSConfirm(){
      
      let base64=this.$refs.ps.invoke('toDataURL')
      fetch('https://pgm.techinao.com/upload/'+this.curCarId+'/'+this.curRow.fileName,{
        method:'POST',
        body:JSON.stringify({base64:base64}),
        headers: new Headers({
          'Content-Type': 'application/json'
        }),
        mode: 'cors',
      }).then(res=>res.json().then(data=>{
        if (data.result=='0') {
          this.$message.success('保存成功.')
        }else{
          this.$message.error(data.message)
        }
      })).catch(err=>{
        console.log(err)
        this.$message.error('请求发生错误，请查看控制台.')
      })
      this.psDialogVisible=false
    },
    setBrush(){
      let color=document.querySelector(".tie-draw-color .color-picker-value").style.backgroundColor //.colorHex().substring(1)
      let width= parseInt(document.querySelector(".tie-draw-range-value").value)
      console.log(color,width)
      this.$refs.ps.invoke('setBrush',{width:width,color:color})
      // this.$refs.ps.invoke('setBrush',{width:12,color:'00a9ff'})
    }
    // setBrush(){
    //   this.$refs.ps.invoke('setBrush',{width:8,color:'000'})
    // },
    // cancleBrush(){
    //   this.$refs.ps.invoke('setBrush',{width:8,color:'fff'})
    // },
  },
  mounted(){
      this.handleFilterCar()
  },
}
</script>

<style>
.shadow{
    height: 750px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.map-file{
    padding-top: 10px;
    padding-left: 10px;
}
.car-id{
    padding-bottom: 20px;
}
.ps{
  height: 80vh;
}
</style>
